import { jsxs as d, jsx as e } from "react/jsx-runtime";
import { forwardRef as m } from "react";
import x from "@mui/material/Alert";
import n from "styled-components";
import f from "../../icons/error.js";
import h from "../../icons/info.js";
import u from "../../icons/success.js";
import y from "../../icons/warning.js";
import A from "./components/AlertTitle.js";
const w = {
  root: "alertRoot",
  icon: "alertIcon",
  message: "alertMessage",
  action: "alertAction"
}, $ = n(A).withConfig({
  displayName: "StyledAlertTitle"
})([
  "&&&{text-align:'center';font-weight:500;line-height:24px;font-size:16px;color:",
  ";margin-bottom:",
  ";}"
], ({ theme: t }) => t.color.text.highemphasis, ({ $needMargin: t }) => t ? "4px" : "0px"), b = n(x).withConfig({
  displayName: "StyledAlert"
})([
  "&&.alertRoot{width:",
  ";box-sizing:border-box;font-weight:",
  ";padding:16px 20px;background-color:",
  ";}&& .alertIcon{display:flex;margin-right:8px;align-items:",
  ";padding:",
  ";color:",
  ";svg{height:20px;width:20px;}}&& .alertMessage{font-size:14px;padding:0px 0px;color:",
  ";align-content:center;}&& .alertAction{padding:0px 0px 0px 16px;margin-right:0px;align-items:center;}"
], ({ $fullWidth: t }) => t ? "100%" : "auto", (t) => t.theme.typography.fontWeightRegular, ({ theme: t, $severity: o }) => t.palette[o].light, ({ $title: t }) => t ? "flex-start" : "center", ({ $title: t }) => t ? "2px 0 0 0" : "0px 0 0 0", ({ theme: t, $severity: o }) => t.component.banner.color.icon[o], ({ theme: t }) => t.color.text.highemphasis), I = /* @__PURE__ */ m(({ classes: t, children: o, severity: r = "info", variant: l = "standard", fullWidth: a = !0, title: i = void 0, iconMapping: p = void 0, onClose: s = void 0, ...c }, g) => /* @__PURE__ */ d(b, {
  ...c,
  ref: g,
  classes: {
    ...w,
    ...t
  },
  severity: r,
  $title: i,
  $severity: r,
  $fullWidth: a,
  onClose: s,
  variant: l,
  iconMapping: {
    error: /* @__PURE__ */ e(f, {}),
    info: /* @__PURE__ */ e(h, {}),
    success: /* @__PURE__ */ e(u, {}),
    warning: /* @__PURE__ */ e(y, {}),
    ...p
  },
  children: [
    i ? /* @__PURE__ */ e($, {
      severity: r,
      $needMargin: !!o,
      children: i
    }) : null,
    o
  ]
}));
I.displayName = "Alert";
export {
  I as default
};
